import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { getDefaultModuleSpecs } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getDisplayOrderDefaultModuleIds
// @ts-expect-error Cannot find declaration for module
} from 'EmailEditorUI/utils/moduleUtils';
import RenderModules from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/RenderModules';
import PaymentModule from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/PaymentModuleTile';
import AddPanelExpandableSection from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/AddPanelExpandableSections';
import { moduleTilesCategorizer } from 'LayoutBuilderUI/components/panels/sidebar/utils/moduleTilesCategorizer';
import { getModulesSearchTerm } from 'EmailEditorUI/redux/selectors/selected';
import SearchFilteredModules from 'LayoutBuilderUI/components/panels/sidebar/SearchFilteredModules';
import { getCountOfDefaultFilteredModules, getRecentModuleSpecsAsArray } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import ExpandableSectionBorderlessHeader from 'messaging-editing-lib/utilityUI/ExpandableSectionBorderlessHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultModulesSection = () => {
  const moduleSpecs = useSelector(getDefaultModuleSpecs);
  const displayOrderDefaultModuleIds = useSelector(getDisplayOrderDefaultModuleIds);
  const countOfDefaultFilteredModules = useSelector(getCountOfDefaultFilteredModules);
  const recentlyUsedModules = useSelector(getRecentModuleSpecsAsArray);
  const searchTerm = useSelector(getModulesSearchTerm);
  const idsWithSpecs = displayOrderDefaultModuleIds.filter(id => Object.prototype.hasOwnProperty.call(moduleSpecs, id));
  const categorizedModules = moduleTilesCategorizer(idsWithSpecs);
  const renderModuleSection = (title, moduleIds, section) => {
    const modules = moduleIds.map(id => moduleSpecs[id]);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockStart: "200",
        marginBlockEnd: "0",
        marginInlineStart: "100",
        color: "text-core-subtle",
        typography: "heading-25",
        children: title
      }), /*#__PURE__*/_jsx(RenderModules, {
        modules: modules,
        withStoringInRecentlyUsed: true,
        children: section === 'ecommerce' && /*#__PURE__*/_jsx(PaymentModule, {})
      })]
    });
  };
  if (searchTerm) {
    return /*#__PURE__*/_jsx(AddPanelExpandableSection, {
      name: "default-modules-section",
      disabled: countOfDefaultFilteredModules === 0,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.addPanel.defaultModules.header",
        options: {
          numberOfModules: countOfDefaultFilteredModules
        }
      }),
      Header: ExpandableSectionBorderlessHeader,
      indentation: "compact",
      removeRightPaddingFromContent: true,
      children: /*#__PURE__*/_jsx(SearchFilteredModules, {})
    });
  }
  return /*#__PURE__*/_jsxs(AddPanelExpandableSection, {
    name: "default-modules-section",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.header",
      options: {
        numberOfModules: idsWithSpecs.length + 1 // +1 to account for payments module
      }
    }),
    indentation: "compact",
    removeRightPaddingFromContent: true,
    Header: recentlyUsedModules.length > 0 ? undefined : ExpandableSectionBorderlessHeader,
    children: [renderModuleSection( /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.titles.base"
    }), categorizedModules.base, 'base'), renderModuleSection( /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.titles.media"
    }), categorizedModules.media, 'media'), renderModuleSection( /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.titles.structure"
    }), categorizedModules.structure, 'structure'), renderModuleSection( /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultModules.titles.ecommerce"
    }), categorizedModules.ecommerce, 'ecommerce')]
  });
};
export default DefaultModulesSection;